export const aboutData = {
  brandName: '今日吃瓜',
  tagline: '全网热门事件一站式聚合平台',
  foundedYear: '2024',
  description: `今日吃瓜创立于2024年，是国内领先的全网热门事件聚合平台。我们致力于通过结构化入口聚合全网热门事件、独家黑料曝光与每日吃瓜大赛，实时更新51在线资源，为吃瓜群众提供一站式浏览体验。

我们的团队由资深媒体人、数据分析师和技术极客组成，核心成员均来自国内一线互联网公司和主流媒体。我们用技术手段对全网热点进行实时监控、智能聚合和深度挖掘，确保每一位吃瓜用户都能第一时间获取最新、最全、最准的吃瓜资讯。

截至目前，今日吃瓜已累计聚合超过5000条热门事件，独家挖掘黑料曝光超过800条，每日吃瓜大赛参与人数突破15万。我们的使命是：让每一个吃瓜群众都能轻松吃到最新鲜的瓜。`,
  images: [
    {
      url: 'https://readdy.ai/api/search-image?query=Modern%20newsroom%20open%20workspace%20collaborative%20team%20working%20on%20computers%20warm%20lighting%20contemporary%20office%20design%20editorial%20photography%20professional%20atmosphere%20clean%20aesthetic%20natural%20light&width=600&height=400&seq=about-brand-01&orientation=landscape',
      alt: '今日吃瓜团队办公环境',
    },
    {
      url: 'https://readdy.ai/api/search-image?query=Team%20brainstorming%20session%20creative%20meeting%20room%20diverse%20group%20discussing%20ideas%20warm%20modern%20office%20atmosphere%20editorial%20photography%20professional%20style%20clean%20composition%20natural%20light&width=800&height=500&seq=about-brand-02&orientation=landscape',
      alt: '今日吃瓜团队头脑风暴',
    },
  ],
  stats: [
    { value: '5000+', label: '聚合事件' },
    { value: '800+', label: '独家爆料' },
    { value: '15W+', label: '日活用户' },
    { value: '99.9%', label: '更新率' },
  ],
  contactInfo: {
    email: 'admin@mxrxlb125.cn',
    wechat: 'mxrxlb125',
    weibo: '@今日吃瓜官方',
  },
};

export const aboutTestimonials = [
  {
    id: 'at1',
    name: '吃瓜小能手',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%20casual%20style%20friendly%20expression%20warm%20lighting%20minimal%20background%20clean%20studio%20photography&width=100&height=100&seq=avatar-at1&orientation=squarish',
    content: '自从发现了今日吃瓜，我再也不用到处刷微博刷豆瓣了！所有热门事件一站式搞定，每天打开看看就知道今天发生了什么，真的是吃瓜群众的福音！界面也很清爽，分类很清楚。',
    rating: 5,
    date: '2026-06-25',
  },
  {
    id: 'at2',
    name: '资深瓜农',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Stylish%20Chinese%20woman%20portrait%20confident%20expression%20warm%20lighting%20clean%20studio%20background%20professional%20photography&width=100&height=100&seq=avatar-at2&orientation=squarish',
    content: '黑料曝光区太给力了！很多独家内容在其他平台根本看不到，更新速度也特别快。51在线入口也很方便，资源整理得很齐全。已经成为我每天的必刷网站了。',
    rating: 5,
    date: '2026-06-24',
  },
  {
    id: 'at3',
    name: '吃瓜路人甲',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20relaxed%20smile%20casual%20outfit%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-at3&orientation=squarish',
    content: '每日吃瓜大赛真的太上头了！每天投票选出最劲爆的瓜，还能看到实时排行榜。评论区也很有意思，大家都是段子手。吃瓜不仅能看热闹，还能交到志同道合的朋友。',
    rating: 4,
    date: '2026-06-23',
  },
  {
    id: 'at4',
    name: '爆料一线',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Trendy%20Chinese%20woman%20portrait%20fashionable%20style%20warm%20smile%20clean%20studio%20background%20professional%20photography%20soft%20lighting&width=100&height=100&seq=avatar-at4&orientation=squarish',
    content: '作为经常冲在第一线的吃瓜人，我负责任地说今日吃瓜是目前信息最全、更新最快的吃瓜平台。结构化分类也很清晰，找瓜特别方便！强烈推荐给每一个吃瓜爱好者。',
    rating: 5,
    date: '2026-06-22',
  },
  {
    id: 'at5',
    name: '夜猫吃瓜',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20man%20portrait%20night%20owl%20vibe%20casual%20hoodie%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-at5&orientation=squarish',
    content: '深夜吃瓜必备！经常半夜还能刷到最新爆料，这更新速度真的没谁了。51在线资源也是深夜党福音。唯一希望的是能加个夜间模式，不然半夜刷手机眼睛有点吃不消哈哈。',
    rating: 4,
    date: '2026-06-21',
  },
  {
    id: 'at6',
    name: '理性吃瓜人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20woman%20portrait%20elegant%20style%20warm%20lighting%20clean%20studio%20background%20professional%20photography%20soft%20expression&width=100&height=100&seq=avatar-at6&orientation=squarish',
    content: '很喜欢吃瓜大赛的"真假鉴定"环节，不会盲目跟风，有专业人士分析事件真伪。理性吃瓜才是好瓜民！推荐给大家。希望平台越做越好，保持客观中立的态度。',
    rating: 5,
    date: '2026-06-20',
  },
  {
    id: 'at7',
    name: '追瓜达人',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20energetic%20expression%20casual%20style%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-at7&orientation=squarish',
    content: '从内测就开始用了，看着今日吃瓜一步步成长起来的。现在的功能越来越完善，分类也越来越细。特别喜欢51在线入口，资源整理得特别用心。',
    rating: 5,
    date: '2026-06-19',
  },
  {
    id: 'at8',
    name: '吃瓜小透明',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Chinese%20young%20woman%20portrait%20shy%20smile%20casual%20style%20warm%20lighting%20clean%20studio%20background%20professional%20photography&width=100&height=100&seq=avatar-at8&orientation=squarish',
    content: '平时不怎么爱发言，但每天都会默默刷今日吃瓜。信息真的很全很及时，而且页面没有乱七八糟的广告，浏览体验很好。已经推荐给好几个朋友了！',
    rating: 5,
    date: '2026-06-18',
  },
  {
    id: 'at9',
    name: '行业观察者',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20man%20portrait%20serious%20expression%20business%20style%20warm%20lighting%20clean%20studio%20background%20professional%20headshot&width=100&height=100&seq=avatar-at9&orientation=squarish',
    content: '作为媒体行业从业者，我不得不说今日吃瓜的聚合能力真的很强。很多事件的梳理比专业媒体还清晰，时间线、关键人物、事件脉络一目了然。黑料曝光区的内容也很有深度。',
    rating: 4,
    date: '2026-06-17',
  },
];
